import React, { useEffect, useState } from "react";
import {
    Card,
    CardBody,
    CardHeader,
    Container,
    Spinner,
} from "reactstrap";
import { MetaTags } from "react-meta-tags";
import {
    Breadcrumb_inputName,
    commonPageField,
    commonPageFieldSuccess,
    editGroupIDSuccess,
} from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
    comAddPageFieldFunc,
    initialFiledFunc,
} from "../../../components/Common/validationFunction";
import {
    loginCompanyID,
    loginPartyID,
    loginSelectedPartyID,
    loginUserID,
    metaTagLabel
} from "../../../components/Common/CommonFunction";
import { mode, url, pageId } from "../../../routes/index";
import { saveMsgUseEffect, userAccessUseEffect } from "../../../components/Common/CommonUseEffect";
import { getpartysetting_API, savePartySettingMaster_Success } from "../../../store/Administrator/PartySetting/action";
import Select from "react-select";
import { getRole } from "../../../store/Administrator/RoleMasterRedux/action";
import { getPartyTypelist } from "../../../store/Administrator/PartyTypeRedux/action";
import { updateSystemSettingID, updateSystemSettingIDSuccess } from "../../../store/Utilites/SystemSettingRedux/action";
import { customAlert } from "../../../CustomAlert/ConfirmDialog";
import { fetch_CompanyList } from "../../../helpers/backend_helper";
import usePartyOptionsFromSetting from "../../../components/Common/CommonPartyOptions";


const ManagementSettings = (props) => {

    const history = useHistory()
    const dispatch = useDispatch();
    const fileds = {
    }
    const [companyOptions, setCompanyOptions] = useState([]);
    const [state, setState] = useState(() => initialFiledFunc(fileds))
    const [pageMode, setPageMode] = useState(mode.defaultsave);
    const [userPageAccessState, setUserAccState] = useState('');
    const [loadingId, setLoadingId] = useState(null);
    const [dynamicValues, setDynamicValues] = useState({});
    const [openSelectCardId, setOpenSelectCardId] = useState(null);
    const [currentRow, setCurrentRow] = useState({
        partyTypeId: "",
        routeId: "",
        startTime: "",
        endTime: ""
    });
    const [currentRowSR, setCurrentRowSR] = useState({
        customerTypeId: "",
        supplierTypeId: "",
        dateStart: ""
    });
    const { options: commonOptions, loading: loadingCommon } = usePartyOptionsFromSetting("MappingMasterAPI", pageId.MANAGEMENT_SETTINGS);


    //Access redux store Data /  'save_ModuleSuccess' action data
    const {
        PartySettingdata,
        pageField,
        postMsg,
        commonPartyDropSelect,
        roleList,
        ListData,
        updateMsg,
        userAccess, } = useSelector((state) => ({
            postMsg: state.PartySettingReducer.postMsg,
            PartySettingdata: state.PartySettingReducer.PartySettingdata,
            updateMsg: state.GroupReducer.updateMsg,
            userAccess: state.Login.RoleAccessUpdateData,
            pageField: state.CommonPageFieldReducer.pageField,
            commonPartyDropSelect: state.CommonPartyDropdownReducer.commonPartyDropSelect,
            roleList: state.RoleMaster_Reducer.roleList,
            ListData: state.PartyTypeReducer.ListData,
            updateMsg: state.SystemSettingReducer.updateMsg,
        }));


    const location = { ...history.location }
    const hasShowloction = location.hasOwnProperty(mode.editValue)
    const hasShowModal = props.hasOwnProperty(mode.editValue)
    const PartyId = loginSelectedPartyID() === 0 ? loginPartyID() : loginSelectedPartyID();
    const settingUIConfig = {
        11: { type: "number", label: "TCS Valid %" },
        12: { type: "number", label: "TCS Invalid %" },
        15: { type: "multiSelect", source: "role" },
        34: { type: "multiSelect", source: "partyType" },
        44: { type: "multiSelect", source: "partyType" },
        42: { type: "mapping", source: "companyMode" },
        60: { type: "boolean" },
        61: { type: "multiSelect", source: "company" },
        32: { type: "salesReturnSendToSupplier" },
        45: { type: "multiSelect", source: "partyType" },       // IsChannelItem: single PartyType id
        56: { type: "multiSelect", source: "partyType" },    // Auto Stock Processing: PartyTypes list
        49: { type: "timeWindow" },
        72: { type: "multiSelect", source: "role" },
        76: { type: "boolean" },
        77: { type: "replaceMappingParty", source: "partyType" },
        90: { type: "boolean" },
        93: { type: "multiSelect", source: "partyType" },
        96: { type: "boolean" },
        98: { type: "boolean" }
    };

    useEffect(() => {
        const page_Id = pageId.MANAGEMENT_SETTINGS
        dispatch(commonPageFieldSuccess(null));
        dispatch(commonPageField(page_Id))


    }, []);

    useEffect(() => {

        if (commonPartyDropSelect) {
            dispatch(getpartysetting_API(loginSelectedPartyID(), loginCompanyID()))
        }
    }, [commonPartyDropSelect]);

    // userAccess useEffect
    useEffect(() => userAccessUseEffect({
        props,
        userAccess,
        dispatch,
        setUserAccState,
    }), [userAccess]);


    useEffect(() => {

        if ((hasShowloction || hasShowModal)) {

            let hasEditVal = null
            if (hasShowloction) {
                setPageMode(location.pageMode)
                hasEditVal = location.editValue
            }
            else if (hasShowModal) {
                hasEditVal = props.editValue
                setPageMode(props.pageMode)
            }

            if (hasEditVal) {

                const { id, Name, GroupType, GroupTypeName } = hasEditVal
                const { values, fieldLabel, hasValid, required, isError } = { ...state }

                values.Name = Name;
                values.id = id
                values.GroupTypeName = { label: GroupTypeName, value: GroupType };

                hasValid.Name.valid = true;
                hasValid.GroupTypeName.valid = true;

                setState({ values, fieldLabel, hasValid, required, isError })
                dispatch(Breadcrumb_inputName(hasEditVal.Name))
            }
            dispatch(editGroupIDSuccess({ Status: false }))
        }
    }, [])

    useEffect(() => {
        if (updateMsg?.Status === true && updateMsg?.StatusCode === 200) {

            setLoadingId(null);

            // ✅ Use API message instead of hardcoded
            customAlert({
                Type: 1,
                Message: updateMsg?.Message || "Updated successfully"
            });

            dispatch(getpartysetting_API(loginSelectedPartyID(), loginCompanyID()));

            // 🔥 VERY IMPORTANT → RESET
            dispatch(updateSystemSettingIDSuccess({ Status: false }));

        } else if (updateMsg?.Status === true) {

            setLoadingId(null);

            customAlert({
                Type: 3,
                Message: updateMsg?.Message || "Something went wrong"
            });

            // 🔥 RESET here also
            dispatch(updateSystemSettingIDSuccess({ Status: false }));
        }
    }, [updateMsg]);

    useEffect(() => saveMsgUseEffect({
        postMsg, pageMode,
        history, dispatch,
        postSuccss: savePartySettingMaster_Success,
        resetFunc: { fileds, state, setState },
        listPath: url.MANAGEMENT_SETTINGS,
    }), [postMsg])

    useEffect(() => {
        dispatch(getpartysetting_API(loginSelectedPartyID(), loginCompanyID()))
    }, [postMsg])

    useEffect(() => {
        const fetchData = async () => {
            try {
                //This HardCoded Data For Here I Want All Company List So we Used Hardcoded jsonBody For Management Settings Only.
                const JsonBody = {
                    UserID: 1,
                    RoleID: 1,
                    CompanyID: 0,
                    PartyID: 100,
                    IsSCMCompany: 1,
                    CompanyGroup: 1,
                };

                const response = await fetch_CompanyList(JSON.stringify(JsonBody));

                // ✅ Bind directly here
                const options = response?.Data?.map(i => ({
                    value: i.id,
                    label: i.Name
                })) || [];

                setCompanyOptions(options);
                dispatch(getPartyTypelist());
                dispatch(getRole());
            } catch (error) {
                console.error("Error fetching company list:", error);
            }
        };

        fetchData();
    }, []);


    useEffect(() => {
        if (pageField) {
            const fieldArr = pageField.PageFieldMaster
            comAddPageFieldFunc({ state, setState, fieldArr })
        }
    }, [pageField])

    const parseTimeWindow = (val) => {
        if (!val) return [];

        return val.split(",").map(v => {
            const [left, timePart] = v.split("(") || [];
            const [partyTypeId, routeId] = (left || "").split("-");
            const time = (timePart || "").replace(")", "");
            const [start, end] = time.split("-");

            return {
                partyTypeId: partyTypeId || "",
                routeId: routeId || "",
                startTime: start || "",
                endTime: end || ""
            };
        });
    };

    const buildTimeWindow = (rows) => {
        return rows
            .map(r =>
                `${r.partyTypeId || ""}-${r.routeId || ""}(${r.startTime || ""}-${r.endTime || ""})`
            )
            .join(",");
    };

    const getOptions = (source) => {
        switch (source) {
            case "partyType":
                return partyTypeOptions;

            case "role":
                return roleOptions;

            case "company":
                return companyOptions;

            default:
                return [];
        }
    };

    // setting 32 format:
    // "CustomerPartyTypeID-SupplierPartyTypeID-LockDateStart,CustomerPartyTypeID-SupplierPartyTypeID-LockDateStart,..."
    const parseSalesReturnSendToSupplier = (val) => {
        if (!val) return [];
        return String(val)
            .split(",")
            .map((chunk) => chunk.trim())
            .filter(Boolean)
            .map((chunk) => {
                const parts = chunk.split("-");
                const customerTypeId = parts[0] ?? "";
                const supplierTypeId = parts[1] ?? "";
                const dateStart = parts.slice(2).join("-");
                return { customerTypeId, supplierTypeId, dateStart };
            });
    };

    const parseReplaceMapping = (val) => {
        if (!val) return { partyIds: [], key: "" };

        const [left, right] = val.split("=");

        return {
            partyIds: left ? left.split(",").map(i => i.trim()) : [],
            key: right ? right.trim() : ""
        };
    };

    const buildSalesReturnSendToSupplierValue = (rows) => {
        return (rows || [])
            .map((r) => `${r.customerTypeId || ""}-${r.supplierTypeId || ""}-${r.dateStart || ""}`)
            .join(",");
    };

    const convertTo12 = (time24) => {
        if (!time24) return "";
        let [h, m] = time24.split(":");
        let ampm = h >= 12 ? "PM" : "AM";
        h = h % 12 || 12;
        return `${String(h).padStart(2, "0")}:${m}:${ampm}`;
    };

    const convertTo24 = (time12) => {
        if (!time12) return "";

        const [h, m, ampm] = time12.split(":");

        let hour = parseInt(h, 10);

        if (ampm === "PM" && hour !== 12) hour += 12;
        if (ampm === "AM" && hour === 12) hour = 0;

        return `${String(hour).padStart(2, "0")}:${m}`;
    };

    const MappingTable = ({ value, onChange, companyOptions }) => {

        const [currentRow, setCurrentRow] = useState({ company: "", mode: "" });

        const parse = (val) =>
            val ? val.split(",").map(v => {
                const [c, m] = v.split("-");
                return { company: c, mode: m };
            }) : [];

        const updateRow = (rows) => {
            const final = rows.map(r => `${r.company}-${r.mode}`).join(",");
            onChange(final);
        };

        const rows = parse(value);

        return (
            <div style={{
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                padding: "10px",
                background: "#fff"
            }}>

                {/* HEADER */}
                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: "12px",
                    fontWeight: 600,
                    marginBottom: "8px",
                    color: "#6b7280"
                }}>
                    <span style={{ width: "45%" }}>Company</span>
                    <span style={{ width: "45%" }}>Mode</span>
                    <span style={{ width: "10%" }}></span>
                </div>

                {/* SINGLE INPUT ROW */}
                <div style={{
                    display: "flex",
                    gap: "8px",
                    marginBottom: "10px",
                    alignItems: "center",
                    padding: "6px",
                    border: "1px dashed #d1d5db",
                    borderRadius: "6px",
                    background: "#f9fafb"
                }}>
                    {/* Company */}
                    <div style={{ width: "45%" }}>
                        <Select
                            styles={customSelectStyles}
                            options={companyOptions}
                            value={companyOptions.find(o => String(o.value) === String(currentRow.company)) || null}
                            onChange={(val) => {
                                setCurrentRow(prev => ({ ...prev, company: val?.value || "" }));
                            }}
                        />
                    </div>

                    {/* Mode */}
                    <div style={{ width: "45%" }}>
                        <Select
                            styles={customSelectStyles}
                            options={[
                                { value: 1, label: "MRP" },
                                { value: 2, label: "Rate" }
                            ]}
                            value={[
                                { value: 1, label: "MRP" },
                                { value: 2, label: "Rate" }
                            ].find(o => String(o.value) === String(currentRow.mode)) || null}
                            onChange={(val) => {
                                setCurrentRow(prev => ({ ...prev, mode: val?.value || "" }));
                            }}
                        />
                    </div>
                    <div style={{ width: "10%" }} />
                </div>

                {/* ADDED ROWS */}
                {rows.map((row, i) => (
                    <div key={i} style={{
                        display: "flex",
                        gap: "8px",
                        marginBottom: "8px",
                        alignItems: "center",
                        padding: "8px",
                        border: "1px dashed #e5e7eb",
                        borderRadius: "8px",
                        background: "#F8FAFC",
                        boxShadow: "0 1px 2px rgba(0,0,0,0.05)"
                    }}>

                        {/* Company Text */}
                        <div style={{ width: "45%" }}>
                            {companyOptions.find(o => String(o.value) === String(row.company))?.label || "-"}
                        </div>

                        {/* Mode Text */}
                        <div style={{ width: "45%" }}>
                            {row.mode == 1 ? "MRP" : row.mode == 2 ? "Rate" : "-"}
                        </div>

                        {/* REMOVE BUTTON */}
                        <button
                            type="button"
                            onClick={() => {
                                const newRows = rows.filter((_, index) => index !== i);
                                updateRow(newRows);
                            }}
                            style={{
                                background: "transparent",
                                border: "none",
                                color: "#ef4444",
                                cursor: "pointer",
                                fontSize: "16px"
                            }}
                        >
                            ✕
                        </button>

                    </div>
                ))}

                {/* ADD BUTTON */}
                <button
                    type="button"
                    onClick={() => {
                        if (!currentRow.company || !currentRow.mode) return;
                        const next = [...rows, currentRow];
                        updateRow(next);
                        setCurrentRow({ company: "", mode: "" });
                    }}
                    style={{
                        marginTop: "6px",
                        padding: "5px 10px",
                        borderRadius: "6px",
                        border: "1px dashed #6366f1",
                        background: "#eef2ff",
                        color: "#4338ca",
                        cursor: "pointer",
                        fontSize: "13px"
                    }}
                >
                    + Add Row
                </button>

            </div>
        );
    };
    const buildReplaceMapping = ({ partyIds, key }) => {
        return `${(partyIds || []).join(",")} = ${key || ""}`;
    };
    const renderPreview = (item, value) => {
        const config = settingUIConfig[item.id];

        if (!value) return null;

        switch (config?.type) {

            case "boolean":
                return (
                    <div style={previewStyle}>
                        {value === "1" || value === "true" ? "Enabled" : "Disabled"}
                    </div>
                );

            case "multiSelect":
                const options = getOptions(config.source);
                const labels = value
                    .split(",")
                    .map(v => options.find(o => o.value == v)?.label)
                    .filter(Boolean)
                    .join(", ");

                return <div style={previewStyle}>{labels}</div>;

            case "dropdown":
                const opts = getOptions(config.source);
                const label = opts.find(o => o.value == value)?.label;

                return <div style={previewStyle}>{label}</div>;

            case "mapping":
                const rows = value.split(",").map(v => {
                    const [c, m] = v.split("-");
                    return {
                        company: companyOptions.find(o => o.value == c)?.label,
                        mode: m == 1 ? "MRP" : "Rate"
                    };
                });
                return (
                    <div style={previewStyle}>
                        {rows.map((r, i) => (
                            <div key={i}>
                                {r.company} → {r.mode}
                            </div>
                        ))}
                    </div>
                );

            case "salesReturnSendToSupplier":
                const lockRows = parseSalesReturnSendToSupplier(value);
                const partyTypeById = (partyTypeOptions || []).reduce((acc, opt) => {
                    acc[String(opt.value)] = opt.label;
                    return acc;
                }, {});

                return (
                    <div style={previewStyle}>
                        {lockRows.map((r, i) => (
                            <div key={i}>
                                {partyTypeById[String(r.customerTypeId)] || r.customerTypeId} →{" "}
                                {partyTypeById[String(r.supplierTypeId)] || r.supplierTypeId} :{" "}
                                {r.dateStart}
                            </div>
                        ))}
                    </div>
                );
            case "replaceMappingParty":
                const parsed = parseReplaceMapping(value);

                return (
                    <div style={previewStyle}>
                        Parties: {
                            parsed.partyIds
                                .map(id => commonOptions.find(p => p.value == id)?.label)
                                .filter(Boolean)
                                .join(", ")
                        }
                        <br />
                        → {parsed.key}
                    </div>
                );
            default:
                return <div style={previewStyle}>{value}</div>;
        }
    };

    const renderField = (item, value) => {
        const config = settingUIConfig[item.id];

        if (!config) {
            return <input value={value} onChange={(e) => update(item.id, e.target.value)} />;
        }

        switch (config.type) {

            case "boolean":
                return (
                    <label style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        cursor: "pointer"
                    }}>

                        <span style={{ fontSize: "13px", fontWeight: 500 }}>
                            Enable
                        </span>

                        <div style={{
                            width: "40px",
                            height: "20px",
                            background: value === "1" || value === "true" ? "#6366f1" : "#d1d5db",
                            borderRadius: "999px",
                            position: "relative",
                            transition: "0.3s"
                        }}>
                            <div style={{
                                width: "16px",
                                height: "16px",
                                background: "#fff",
                                borderRadius: "50%",
                                position: "absolute",
                                top: "2px",
                                left: value === "1" || value === "true" ? "22px" : "2px",
                                transition: "0.3s"
                            }} />
                        </div>

                        <input
                            type="checkbox"
                            checked={value === "1" || value === "true"}
                            onChange={(e) => update(item.id, e.target.checked ? "1" : "0")}
                            style={{ display: "none" }}
                        />
                    </label>
                );

            case "number":
                return (
                    <input
                        type="text"
                        style={commonInputStyle}
                        value={value}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        onChange={(e) => update(item.id, e.target.value)}
                    />
                );

            case "dropdown":
                const options = getOptions(config.source);
                return (
                    <Select
                        styles={customSelectStyles}
                        options={options}
                        value={options.find(o => o.value == value)}
                        onMenuOpen={() => setOpenSelectCardId(item.id)}
                        onMenuClose={() => setOpenSelectCardId(null)}
                        onChange={(val) => update(item.id, val.value)}
                    />
                );

            case "multiSelect":
                const multiOptions = getOptions(config.source);
                return (
                    <Select
                        isMulti
                        options={multiOptions}
                        value={multiOptions.filter(o => value?.split(",").includes(String(o.value)))}
                        onChange={(val) => update(item.id, val.map(i => i.value).join(","))}
                        onMenuOpen={() => setOpenSelectCardId(item.id)}
                        onMenuClose={() => setOpenSelectCardId(null)}
                        styles={customSelectStyles}
                    />
                );

            case "mapping":
                return (
                    <MappingTable
                        value={value}
                        onChange={(val) => update(item.id, val)}
                        companyOptions={companyOptions}
                    />
                );

            case "salesReturnSendToSupplier": {
                const lockRowsField = parseSalesReturnSendToSupplier(value);
                const rows = lockRowsField.length
                    ? lockRowsField
                    : [];

                const partyTypeOpts = partyTypeOptions || [];

                return (
                    <div style={{
                        border: "1px solid #e5e7eb",
                        borderRadius: "8px",
                        padding: "10px",
                        background: "#fff"
                    }}>
                        {/* HEADER */}
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            fontSize: "12px",
                            fontWeight: 600,
                            marginBottom: "8px",
                            color: "#6b7280"
                        }}>
                            <span style={{ width: "32%" }}>Customer</span>
                            <span style={{ width: "32%" }}>Supplier</span>
                            <span style={{ width: "32%" }}>Lock Date</span>
                        </div>
                        {/* SINGLE INPUT ROW */}
                        <div style={{
                            display: "flex",
                            gap: "8px",
                            marginBottom: "10px",
                            alignItems: "center",
                            padding: "6px",
                            border: "1px dashed #d1d5db",
                            borderRadius: "6px",
                            background: "#f9fafb"
                        }}>

                            {/* Customer */}
                            <div style={{ width: "32%" }}>
                                <Select
                                    styles={customSelectStyles}
                                    options={partyTypeOpts}
                                    value={partyTypeOpts.find(o => String(o.value) === String(currentRowSR.customerTypeId)) || null}
                                    onChange={(val) => {
                                        setCurrentRowSR(prev => ({
                                            ...prev,
                                            customerTypeId: val?.value || ""
                                        }));
                                    }}
                                />
                            </div>

                            {/* Supplier */}
                            <div style={{ width: "32%" }}>
                                <Select
                                    styles={customSelectStyles}
                                    options={partyTypeOpts}
                                    value={partyTypeOpts.find(o => String(o.value) === String(currentRowSR.supplierTypeId)) || null}
                                    onChange={(val) => {
                                        setCurrentRowSR(prev => ({
                                            ...prev,
                                            supplierTypeId: val?.value || ""
                                        }));
                                    }}
                                />
                            </div>

                            {/* Date */}
                            <div style={{ width: "32%" }}>
                                <input
                                    type="text"
                                    value={currentRowSR.dateStart}
                                    placeholder="e.g. 24"
                                    onChange={(e) =>
                                        setCurrentRowSR(prev => ({
                                            ...prev,
                                            dateStart: e.target.value
                                        }))
                                    }
                                    style={commonInputStyle}
                                />
                            </div>

                            <div style={{ width: "10px" }} />
                        </div>

                        {rows.map((r, i) => (
                            <div key={i} style={{
                                display: "flex",
                                gap: "8px",
                                marginBottom: "8px",
                                alignItems: "center",
                                padding: "8px",
                                border: "1px dashed #e5e7eb",
                                borderRadius: "8px",
                                background: "#F8FAFC",
                                boxShadow: "0 1px 2px rgba(0,0,0,0.05)"
                            }}>

                                {/* Customer */}
                                <div style={{ width: "32%" }}>
                                    {partyTypeOpts.find(o => String(o.value) === String(r.customerTypeId))?.label || "-"}
                                </div>

                                {/* Supplier */}
                                <div style={{ width: "32%" }}>
                                    {partyTypeOpts.find(o => String(o.value) === String(r.supplierTypeId))?.label || "-"}
                                </div>

                                {/* Date */}
                                <div style={{ width: "32%" }}>
                                    {r.dateStart || "-"}
                                </div>

                                {/* Remove */}
                                <button
                                    type="button"
                                    onClick={() => {
                                        const next = rows.filter((_, index) => index !== i);
                                        update(item.id, buildSalesReturnSendToSupplierValue(next));
                                    }}
                                    style={{
                                        background: "transparent",
                                        border: "none",
                                        color: "#ef4444",
                                        cursor: "pointer",
                                        fontSize: "16px"
                                    }}
                                >
                                    ✕
                                </button>
                            </div>
                        ))}

                        <button
                            type="button"
                            onClick={() => {
                                if (!currentRowSR.customerTypeId || !currentRowSR.supplierTypeId) return;

                                const next = [...rows, currentRowSR];
                                update(item.id, buildSalesReturnSendToSupplierValue(next));

                                setCurrentRowSR({
                                    customerTypeId: "",
                                    supplierTypeId: "",
                                    dateStart: ""
                                });
                            }}
                            style={{
                                marginTop: "6px",
                                padding: "5px 10px",
                                borderRadius: "6px",
                                border: "1px dashed #6366f1",
                                background: "#eef2ff",
                                color: "#4338ca",
                                cursor: "pointer",
                                fontSize: "13px"
                            }}
                        >
                            + Add Row
                        </button>
                    </div>
                );
            }
            case "timeWindow": {

                const rowsParsed = parseTimeWindow(value);

                const rows = rowsParsed.length
                    ? rowsParsed
                    : [];

                const partyTypeOpts = partyTypeOptions || [];

                return (
                    <div style={boxStyle}>

                        {/* HEADER */}
                        <div style={headerStyle}>
                            <span style={{ flex: 1.2 }}>Party</span>
                            <span style={{ flex: 1 }}>Route</span>
                            <span style={{ flex: 1 }}>Start</span>
                            <span style={{ flex: 1 }}>End</span>
                        </div>
                        {/* SINGLE INPUT ROW */}
                        <div style={{
                            display: "flex",
                            gap: "8px",
                            marginBottom: "10px",
                            alignItems: "center",
                            padding: "6px",
                            border: "1px dashed #d1d5db",
                            borderRadius: "6px",
                            background: "#f9fafb"
                        }}>

                            {/* Party */}
                            <div style={{ flex: 2 }}>
                                <Select
                                    options={partyTypeOpts}
                                    value={
                                        partyTypeOpts.find(
                                            o => String(o.value) === String(currentRow.partyTypeId)
                                        ) || null
                                    }
                                    onMenuOpen={() => setOpenSelectCardId(item.id)}
                                    onMenuClose={() => setOpenSelectCardId(null)}
                                    onChange={(val) => {
                                        setCurrentRow(prev => ({
                                            ...prev,
                                            partyTypeId: val?.value || ""
                                        }));
                                    }}
                                    styles={customSelectStyles}
                                />
                            </div>

                            {/* Route */}
                            <div style={{ flex: 1 }}>
                                <input
                                    type="text"
                                    placeholder="Enter Route"
                                    value={currentRow.routeId}
                                    onChange={(e) =>
                                        setCurrentRow(prev => ({
                                            ...prev,
                                            routeId: e.target.value
                                        }))
                                    }
                                    style={commonInputStyle}
                                />
                            </div>

                            {/* Start */}
                            <div style={{ flex: 1 }}>
                                <input
                                    type="time"
                                    value={convertTo24(currentRow.startTime) || ""}
                                    onChange={(e) =>
                                        setCurrentRow(prev => ({
                                            ...prev,
                                            startTime: convertTo12(e.target.value)
                                        }))
                                    }
                                    style={commonInputStyle}
                                />
                            </div>

                            {/* End */}
                            <div style={{ flex: 1 }}>
                                <input
                                    type="time"
                                    value={convertTo24(currentRow.endTime) || ""}
                                    onChange={(e) =>
                                        setCurrentRow(prev => ({
                                            ...prev,
                                            endTime: convertTo12(e.target.value)
                                        }))
                                    }
                                    style={commonInputStyle}
                                />
                            </div>
                        </div>

                        {rows.map((r, i) => (
                            <div key={i} style={{
                                display: "flex",
                                gap: "8px",
                                marginBottom: "8px",
                                alignItems: "center",
                                padding: "8px",
                                border: "1px dashed #e5e7eb",
                                borderRadius: "8px",
                                background: "#F8FAFC",
                                boxShadow: "0 1px 2px rgba(0,0,0,0.05)"
                            }}>

                                {/* Party (TEXT ONLY) */}
                                <div style={{ flex: 2 }}>
                                    {
                                        partyTypeOpts.find(
                                            o => String(o.value) === String(r.partyTypeId)
                                        )?.label || "-"
                                    }
                                </div>

                                {/* Route */}
                                <div style={{ flex: 1 }}>{r.routeId || "-"}</div>
                                {/* Start */}
                                <div style={{ flex: 1 }}>{r.startTime || "-"}</div>
                                {/* End */}
                                <div style={{ flex: 1 }}>{r.endTime || "-"}</div>
                                {/* Remove */}
                                <div style={{ width: "20px" }}>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            const next = rows.filter((_, idx) => idx !== i);
                                            update(item.id, buildTimeWindow(next));
                                        }}
                                        style={{
                                            background: "transparent",
                                            border: "none",
                                            color: "#ef4444",
                                            cursor: "pointer",
                                            fontSize: "16px"
                                        }}
                                    >
                                        ✕
                                    </button>
                                </div>
                            </div>
                        ))}

                        {/* Add Row Button */}
                        <button
                            type="button"
                            onClick={() => {
                                if (!currentRow.partyTypeId) return;

                                const next = [...rows, currentRow];
                                update(item.id, buildTimeWindow(next));

                                setCurrentRow({
                                    partyTypeId: "",
                                    routeId: "",
                                    startTime: "",
                                    endTime: ""
                                });
                            }}
                            style={{
                                marginTop: "6px",
                                padding: "5px 10px",
                                borderRadius: "6px",
                                border: "1px dashed #6366f1",
                                background: "#eef2ff",
                                color: "#4338ca",
                                cursor: "pointer",
                                fontSize: "13px"
                            }}
                        >
                            + Add Row
                        </button>

                    </div>
                );
            }
            case "replaceMappingParty": {

                const parsed = parseReplaceMapping(value);

                return (
                    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>

                        <label style={{ fontSize: "12px", fontWeight: 600 }}>
                            Select Parties
                        </label>

                        <Select
                            isMulti
                            styles={customSelectStyles}
                            options={commonOptions}
                            isLoading={loadingCommon}
                            value={commonOptions.filter(o =>
                                parsed.partyIds.includes(String(o.value))
                            )}
                            onMenuOpen={() => setOpenSelectCardId(item.id)}
                            onMenuClose={() => setOpenSelectCardId(null)}
                            onChange={(val) => {
                                const ids = val.map(v => v.value);

                                update(
                                    item.id,
                                    buildReplaceMapping({
                                        partyIds: ids,
                                        key: parsed.key
                                    })
                                );
                            }}
                        />

                        <label style={{ fontSize: "12px", fontWeight: 600 }}>
                            Replace Key
                        </label>

                        <input
                            type="text"
                            placeholder="Enter key (e.g. 84317)"
                            value={parsed.key}
                            onChange={(e) => {
                                update(
                                    item.id,
                                    buildReplaceMapping({
                                        partyIds: parsed.partyIds,
                                        key: e.target.value
                                    })
                                );
                            }}
                            style={commonInputStyle}
                        />

                    </div>
                );
            }
            default:
                return (
                    <input
                        type="text"
                        style={commonInputStyle}
                        value={value}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        onChange={(e) => update(item.id, e.target.value)}
                    />
                );
        }
    };

    const update = (id, val) => {
        setDynamicValues(prev => ({
            ...prev,
            [id]: val
        }));
    };

    const allowedSettingIds = [11, 12, 15, 32, 34, 42, 44, 45, 49, 56, 60, 61, 72, 76, 77, 90, 93, 96, 98];
    const managementSettings = Array.isArray(PartySettingdata?.Data)
        ? PartySettingdata.Data.filter(item =>
            allowedSettingIds.includes(item.id)
        )
        : Object.values(PartySettingdata?.Data || {}).filter(item =>
            allowedSettingIds.includes(item.id)
        );

    const partyTypeOptions = (ListData).map(i => ({
        value: i.id,
        label: i.Name
    }));

    const roleOptions = (roleList).map(i => ({
        value: i.id,
        label: i.Name
    }));

    const handleUpdate = (item) => {

        setLoadingId(item.id);

        const rawValue = dynamicValues[item.id] ?? item.Value;

        const value = (!rawValue || rawValue === "") ? "0" : rawValue;

        const jsonBody = JSON.stringify({
            SystemSetting: item.SystemSetting,
            Description: item.Description,
            IsActive: item.IsActive,
            IsPartyRelatedSetting: item.IsPartyRelatedSetting,
            DefaultValue: value,
            SettingDetails: [{
                Value: value,
                IsDeleted: 0,
                CreatedBy: loginUserID(),
                UpdatedBy: loginUserID(),
                Company: loginCompanyID()
            }]
        });

        dispatch(updateSystemSettingID({
            jsonBody,
            updateId: item.id
        }));
    };

    return (
        <React.Fragment>
            <div className="page-content" style={{ background: "#f3f4f6", minHeight: "100vh" }}>
                <Container fluid>
                    <MetaTags>{metaTagLabel(userPageAccessState)}</MetaTags>
                    <Card style={mainsectionCardStyle}>
                        <CardHeader className="card-header   text-black c_card_header" >
                            <h4 className="card-title text-black">{userPageAccessState.PageDescription}</h4>
                            <p className="card-title-desc text-black" dangerouslySetInnerHTML={{ __html: userPageAccessState.PageDescriptionDetails }} />
                        </CardHeader>
                        <CardBody className="text-black " style={{ overflow: "visible" }}>
                            <form noValidate>
                                <div style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
                                    gap: "16px",
                                }}>

                                    {managementSettings.map(item => {
                                        const value = dynamicValues[item.id] ?? item.Value;

                                        return (
                                            <Card
                                                key={item.id}
                                                style={{
                                                    ...sectionCardStyle,
                                                    position: "relative",
                                                    // Keep the card above others while its react-select menu is open
                                                    zIndex: openSelectCardId === item.id ? 9999 : 10,
                                                }}
                                                onMouseEnter={(e) => {
                                                    cardHover(e);
                                                }}
                                                onMouseLeave={(e) => {
                                                    cardLeave(e);
                                                }}>
                                                <CardHeader style={{
                                                    ...CardHeaderStyle,
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center"
                                                }}>

                                                    <span>
                                                        {settingUIConfig[item.id]?.label || item.SystemSetting}
                                                    </span>

                                                    <button
                                                        type="button"
                                                        onClick={() => handleUpdate(item)}
                                                        disabled={loadingId === item.id}
                                                        style={{
                                                            padding: "4px 10px",
                                                            fontSize: "12px",
                                                            borderRadius: "6px",
                                                            border: "none",
                                                            background: loadingId === item.id ? "#9ca3af" : "#10b981",
                                                            color: "#fff",
                                                            cursor: loadingId === item.id ? "not-allowed" : "pointer",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "6px"
                                                        }}
                                                    >
                                                        {loadingId === item.id && (
                                                            <Spinner
                                                                size="sm"
                                                                style={{ width: "12px", height: "12px" }}
                                                            />
                                                        )}

                                                        {loadingId === item.id ? "Updating" : "Update"}
                                                    </button>

                                                </CardHeader>
                                                <CardBody style={{ padding: "12px 14px", overflow: "visible" }}>

                                                    {/* Description */}
                                                    {item.Description && (
                                                        <div style={{
                                                            fontSize: "12px",
                                                            color: "#6b7280",
                                                            marginBottom: "8px"
                                                        }}>
                                                            {item.Description}
                                                        </div>
                                                    )}

                                                    {/* Field */}
                                                    <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                                        {/* Editable UI */}
                                                        {renderField(item, value)}
                                                        {/* Preview UI */}
                                                        {renderPreview(item, value)}
                                                    </div>

                                                </CardBody>
                                            </Card>
                                        );
                                    })}
                                </div>
                            </form>
                        </CardBody>
                    </Card>
                </Container >
            </div >
        </React.Fragment >
    );

};

export default ManagementSettings

const cardHover = (e) => {
    e.currentTarget.style.transform = "translateY(-2px)";
    e.currentTarget.style.boxShadow = "0 12px 28px rgba(0,0,0,0.08)";
};

const cardLeave = (e) => {
    e.currentTarget.style.transform = "translateY(0px)";
    e.currentTarget.style.boxShadow = "0 8px 24px rgba(0,0,0,0.06)";
};

const mainsectionCardStyle = {
    borderRadius: "16px",
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    boxShadow: "0 10px 30px rgba(0,0,0,0.05)"
};

const sectionCardStyle = {
    borderRadius: "14px",
    border: "1px solid #e5e7eb",
    background: "#fafafa",   // 🔥 subtle grey
    boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
    overflow: "visible",
    zIndex: 10
};

const CardHeaderStyle = {
    fontWeight: 600,
    fontSize: "14px",
    padding: "8px 12px",
    background: "#eef2ff",
    color: "#4338ca",
    borderBottom: "1px solid #e5e7eb",
    borderLeft: "4px solid #5156be",
    borderTopLeftRadius: "10px",
    borderTopRightRadius: "10px",
}

const customSelectStyles = {
    control: (base) => ({
        ...base,
        minHeight: "38px",
        fontSize: "14px",
        borderRadius: "6px",
        borderColor: "#d1d5db",
        boxShadow: "none",
        alignItems: "flex-start",   // ⭐ allow wrapping
        paddingTop: "2px",
        paddingBottom: "2px"
    }),

    valueContainer: (base) => ({
        ...base,
        padding: "4px 8px",
        display: "flex",
        flexWrap: "wrap",   // ⭐ IMPORTANT
        gap: "4px"
    }),

    multiValue: (base) => ({
        ...base,
        background: "#eef2ff",
        borderRadius: "6px",
        padding: "2px 6px",
        fontSize: "12px"
    }),

    multiValueLabel: (base) => ({
        ...base,
        color: "#4338ca",
        fontWeight: 500
    }),

    multiValueRemove: (base) => ({
        ...base,
        color: "#4338ca",
        cursor: "pointer",
        ':hover': {
            backgroundColor: "#c7d2fe",
            color: "#1e1b4b"
        }
    }),

    option: (base, state) => ({
        ...base,
        fontSize: "14px",
        padding: "10px",
        backgroundColor: state.isSelected
            ? "#6366f1"
            : state.isFocused
                ? "#eef2ff"
                : "white",
        color: state.isSelected
            ? "white"
            : state.isFocused
                ? "#4338ca"
                : "inherit",
    }),

    menu: (base) => ({
        ...base,
        zIndex: 9999
    }),
};

const commonInputStyle = {
    width: "100%",
    height: "38px",
    padding: "6px 10px",
    borderRadius: "6px",
    border: "1px solid #d1d5db",
    fontSize: "14px",
    outline: "none",
    transition: "all 0.2s ease"
};

const handleFocus = (e) => {
    e.target.style.border = "1px solid #6366f1";
    e.target.style.boxShadow = "0 0 0 1px #6366f1";
};

const handleBlur = (e) => {
    e.target.style.border = "1px solid #d1d5db";
    e.target.style.boxShadow = "none";
};

const previewStyle = {
    marginTop: "8px",
    padding: "6px 10px",
    background: "#f1f5f9",
    border: "1px dashed #cbd5f5",
    borderRadius: "6px",
    fontSize: "13px",
    color: "#334155"
};

const boxStyle = {
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    padding: "13px",
    background: "#fff"
};

const headerStyle = {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "12px",
    fontWeight: 600,
    marginBottom: "8px",
    color: "#6b7280"
};